export default "__VITE_ASSET__vqbaZJ7M__"